<div [formGroup]="definitionForm" (ngSubmit)="onSave()">
    <r1-compass-lib-instructions-with-fields-container>
        <r1-compass-lib-instructions instructions headerText="Definition">
            Provide a name and description for the Play. Then, choose Play Builder or Play Importer. Last, enter
            selections for Play Type, Recommendation Lifecycle Rule Set, Hot Play, and any additional fields. Required
            fields are denoted with an asterisk*.
        </r1-compass-lib-instructions>
        <form formArea [formGroup]="definitionForm">
            @if (playIdFormControl.value) {
                <r1-compass-lib-form-row name="Play Id">
                    <mat-form-field>
                        <mat-label>Play Id</mat-label>
                        <input matInput type="text" [formControl]="playIdFormControl" />
                    </mat-form-field>
                </r1-compass-lib-form-row>
            }
            @if (salesforcePlayIdFormControl.value) {
                <r1-compass-lib-form-row name="Salesforce Play Id">
                    <mat-form-field>
                        <mat-label>Salesforce Play Id</mat-label>
                        <input matInput type="text" [formControl]="salesforcePlayIdFormControl" />
                    </mat-form-field>
                </r1-compass-lib-form-row>
            } @else {
                <r1-compass-lib-form-row name="Salesforce Play Id">
                    <mat-form-field>
                        <mat-label>Not Available</mat-label>
                        <input matInput type="text" [formControl]="salesforcePlayIdFormControl" />
                    </mat-form-field>
                </r1-compass-lib-form-row>
            }
            <r1-compass-lib-form-row name="Recommendation Generator Type">
                <mat-form-field>
                    <mat-label>Recommendation Generator Type</mat-label>
                    <input matInput type="text" [formControl]="definitionForm.controls.recommendationGeneratorType" />
                    @if (definitionForm.controls.recommendationGeneratorType.hasError('required')) {
                        <mat-error>Field is required</mat-error>
                    }
                </mat-form-field>
            </r1-compass-lib-form-row>
            <r1-compass-lib-form-row name="Play Internal Name *">
                <mat-form-field>
                    <mat-label>Play Internal Name</mat-label>
                    <input
                        matInput
                        type="text"
                        [formControl]="definitionForm.controls.playInternalName"
                        (input)="fillBoundFormControl('name')" />
                    @if (definitionForm.controls.playInternalName.hasError('required')) {
                        <mat-error>Field is required</mat-error>
                    }
                </mat-form-field>
            </r1-compass-lib-form-row>
            <r1-compass-lib-form-row name="Play Internal Description">
                <mat-form-field>
                    <mat-label>Play Internal Description</mat-label>
                    <input
                        matInput
                        type="text"
                        [formControl]="definitionForm.controls.playInternalDescription"
                        (input)="fillBoundFormControl('desc')" />
                    @if (definitionForm.controls.playInternalDescription.hasError('required')) {
                        <mat-error>Field is required</mat-error>
                    } @else if (definitionForm.controls.playInternalDescription.hasError('maxlength')) {
                        <mat-error>256 characters maximum</mat-error>
                    }
                </mat-form-field>
            </r1-compass-lib-form-row>
            <r1-compass-lib-form-row name="Play Salesforce Name *">
                <mat-form-field>
                    <mat-label>Play Salesforce Name</mat-label>
                    <input
                        matInput
                        type="text"
                        [formControl]="definitionForm.controls.playSalesforceName"
                        (input)="unbindFormControls('name')" />
                    @if (definitionForm.controls.playSalesforceName.hasError('required')) {
                        <mat-error>Field is required</mat-error>
                    }
                </mat-form-field>
            </r1-compass-lib-form-row>
            <r1-compass-lib-form-row name="Play Salesforce Description">
                <mat-form-field>
                    <mat-label>Play Salesforce Description</mat-label>
                    <input
                        matInput
                        type="text"
                        [formControl]="definitionForm.controls.playSalesforceDescription"
                        (input)="unbindFormControls('desc')" />
                    @if (definitionForm.controls.playSalesforceDescription.hasError('required')) {
                        <mat-error>Field is required</mat-error>
                    } @else if (definitionForm.controls.playSalesforceDescription.hasError('maxlength')) {
                        <mat-error>256 characters maximum</mat-error>
                    }
                </mat-form-field>
            </r1-compass-lib-form-row>
            @if (definitionForm.controls.recommendationGeneratorType.value === 'Builder') {
                <r1-compass-lib-form-row name="Recommendation Lifecycle Rule *">
                    <div class="lifecycle-rule-dropdown-container">
                        <mat-form-field>
                            <mat-label>Lifecycle Rule</mat-label>
                            <mat-select [formControl]="definitionForm.controls.recommendationLifecycleRulesetId">
                                @if (selectedInvalidLifecycleRuleset(); as invalidRuleset) {
                                    <mat-option [value]="invalidRuleset.id" disabled>
                                        {{ invalidRuleset.name }} (invalid)
                                    </mat-option>
                                }
                                @for (ruleset of lifecycleRulesets(); track $index) {
                                    <mat-option [value]="ruleset.id">{{ ruleset.name }}</mat-option>
                                }
                            </mat-select>
                            @if (definitionForm.controls.recommendationLifecycleRulesetId.hasError('required')) {
                                <mat-error>Field is required</mat-error>
                            } @else if (
                                definitionForm.controls.recommendationLifecycleRulesetId.hasError(
                                    'invalidLifecycleRule'
                                )
                            ) {
                                <mat-error
                                    >This play uses an invalid lifecycle rule. Select a valid lifecycle rule to
                                    continue.</mat-error
                                >
                            }
                        </mat-form-field>
                        <!--Left as comment for CLOUD-9967 since it sounds like we might revisit fixing it in the future -->
                        <!-- @if (definitionForm.controls.recommendationLifecycleRulesetId.value) {
                            <a
                                type="button"
                                mat-stroked-button
                                [routerLink]="[$ruleLink()]"
                                target="_blank"
                                class="rule-link-button">
                                View Lifecycle Rule
                            </a>
                        } -->
                        @if (ruleDescription()) {
                            <p class="rule-description-container">{{ ruleDescription() }}</p>
                        }
                    </div>
                </r1-compass-lib-form-row>
            }
            @let maxRecordsPerAccountOptions = this.maxRecordsPerAccountOptions();
            @if (maxRecordsPerAccountOptions.length > 0 && shownComponent() === 'Builder') {
                <r1-compass-lib-form-row name="Max Recommendations Per Account *">
                    <mat-form-field>
                        <mat-label>Max Recommendations Per Account</mat-label>
                        <mat-select [formControl]="definitionForm.controls.maxRecordsPerAccount">
                            @for (value of maxRecordsPerAccountOptions; track value) {
                                <mat-option [value]="value">{{ value }}</mat-option>
                            }
                        </mat-select>
                        @if (definitionForm.controls.maxRecordsPerAccount.hasError('required')) {
                            <mat-error>Field is required</mat-error>
                        }
                    </mat-form-field>
                </r1-compass-lib-form-row>
            }
            <r1-compass-lib-form-row name="Product Targeting">
                <p copy>
                    @if (shownComponent() === 'Importer') {
                        The selected Hierarchy Level and Category(ies) define the Play Object for revenue attribution.
                        If left blank, total customer spend is used. For Play Importer plays, these values are static
                        per play and apply to all customers unless updated by a new list upload.
                    } @else if (shownComponent() === 'Builder') {
                        The selected Hierarchy Level and Category(ies) define the Play Object for revenue attribution.
                        If left blank, total customer spend is used. These do not affect segmentation. If "RunTime" is
                        selected, Hierarchy Level is ignored and attribution follows model output categories. Updates
                        only affect new recommendations—existing ones retain prior settings.
                    } @else {
                        Loading...
                    }
                    <a
                        href="https://corpit-thermofisher.atlassian.net/wiki/spaces/DSP/pages/41591793/Scout+User+Guide#Definition"
                        target="_blank"
                        >Learn More</a
                    >.
                </p>
                <form formArea [formGroup]="definitionForm">
                    <div id="hierarchy-and-typeahead-row">
                        <mat-form-field id="hierarchy">
                            <mat-label>Hierarchy Level</mat-label>
                            <mat-select [(value)]="hierarchyLevel" (selectionChange)="onTargetSelect()">
                                @for (level of targetLevels(); track level.displayName) {
                                    <mat-option [value]="level.value" [matTooltip]="level.displayName"
                                        >{{ level.displayName }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <div id="typeahead">
                            <r1-compass-lib-typeahead-search
                                [disabled]="!hierarchyLevel"
                                [valueFormControl]="typeaheadValueControl"
                                [displayFormControl]="typeaheadDisplayControl"
                                [resultDisplayPropertyPath]="'name'"
                                [resultValuePropertyPath]="'code'"
                                [searchResults]="cmtTypeaheadResults"
                                (search)="onTypeaheadSearch($event)"
                                (resultSelection)="onTypeaheadSelection($event)" />
                        </div>
                    </div>
                    <div id="parameters-chip-list" class="white-background">
                        <mat-chip-listbox #chipList aria-label="Add Parameters">
                            @for (chip of definitionForm.controls.targeting.value; track i; let i = $index) {
                                <mat-chip-option
                                    removeable
                                    (removed)="removeChip(i)"
                                    selectable="false"
                                    highlighted="true"
                                    >{{ chip }}
                                    <mat-icon matChipRemove>cancel</mat-icon>
                                </mat-chip-option>
                            }
                        </mat-chip-listbox>
                    </div>
                </form>
            </r1-compass-lib-form-row>
            @for (additionalFieldFormControl of definitionForm.controls.additionalFields.controls; track $index) {
                @if (userDefinedFields().at($index); as userDefinedField) {
                    <r1-compass-lib-form-row [name]="userDefinedField.name + (userDefinedField.required ? ' *' : '')">
                        @if (userDefinedField.helperText) {
                            <fa-icon
                                helperText
                                [icon]="['fas', 'circle-question']"
                                [matTooltip]="userDefinedField.helperText" />
                        }
                        @switch (userDefinedField.type) {
                            @case ('varchar') {
                                <mat-form-field>
                                    <mat-label>
                                        {{ userDefinedField.name }}
                                    </mat-label>
                                    <input matInput type="text" [formControl]="additionalFieldFormControl" />
                                    @if (additionalFieldFormControl.hasError('required')) {
                                        <mat-error>Field is required</mat-error>
                                    }
                                </mat-form-field>
                            }
                            @case ('boolean') {
                                <mat-checkbox [formControl]="additionalFieldFormControl"
                                    >{{ userDefinedField.name }}
                                </mat-checkbox>
                                @if (additionalFieldFormControl.hasError('required')) {
                                    <mat-error>Field is required</mat-error>
                                }
                            }
                            @case ('picklist') {
                                <mat-form-field>
                                    <mat-label>{{ userDefinedField.name }}</mat-label>
                                    <mat-select [formControl]="additionalFieldFormControl">
                                        <mat-option [value]="null">---</mat-option>
                                        @for (
                                            option of userDefinedFields().at($index)!.picklistElements;
                                            track $index
                                        ) {
                                            <mat-option [value]="option.id">{{ option.name }}</mat-option>
                                        }
                                    </mat-select>
                                    @if (additionalFieldFormControl.hasError('required')) {
                                        <mat-error>Field is required</mat-error>
                                    }
                                </mat-form-field>
                            }
                            @case ('date') {
                                <mat-form-field>
                                    <mat-label>Select a date</mat-label>
                                    <input
                                        matInput
                                        readonly
                                        [matDatepicker]="datePicker"
                                        [formControl]="additionalFieldFormControl"
                                        (click)="additionalFieldFormControl.setValue('')"
                                        (dateInput)="onDateInput($event, additionalFieldFormControl)" />
                                    <fa-icon
                                        matSuffix
                                        class="picker-icon"
                                        [icon]="faCalendar"
                                        (click)="datePicker.open()" />
                                    <mat-datepicker #datePicker />
                                    @if (additionalFieldFormControl.hasError('required')) {
                                        <mat-error>Field is required</mat-error>
                                    }
                                </mat-form-field>
                            }
                        }
                    </r1-compass-lib-form-row>
                }
            }
            <div class="footer-container">
                <button mat-raised-button [disabled]="disableSave()" color="primary" type="submit">Save</button>
            </div>
        </form>
    </r1-compass-lib-instructions-with-fields-container>
</div>
